<script lang="ts" setup>
const props = defineProps<{ context: string[] }>()

const currentIndex = ref(0)
const isAnimating = ref(false)
const timeoutId = ref<NodeJS.Timeout | null>(null)
const visibleMessage = ref('')

function handleVisibilityChange (): void {
  if (document.visibilityState === 'visible') {
    startAnimation()
  } else {
    stopAnimation()
  }
}

function startAnimation (): void {
  visibleMessage.value = props.context[currentIndex.value]
  isAnimating.value = true

  timeoutId.value = setInterval(() => {
    isAnimating.value = false

    setTimeout(() => {
      currentIndex.value = (currentIndex.value + 1) % props.context.length
      visibleMessage.value = props.context[currentIndex.value]

      isAnimating.value = true
    }, 500)
  }, 4000)
}

function stopAnimation (): void {
  if (timeoutId.value) {
    clearInterval(timeoutId.value)
    timeoutId.value = null
  }
}

onMounted(() => {
  startAnimation()
  document.addEventListener('visibilitychange', handleVisibilityChange)
})

onUnmounted(() => {
  document.removeEventListener('visibilitychange', handleVisibilityChange)
  stopAnimation()
})
</script>

<template>
  <div class="min-h-13 relative flex overflow-hidden md:items-center md:justify-center">
    <span
      class="transition-all duration-700 ease-in-out"
      :class="{ 'translate-y-6 opacity-0': !isAnimating, 'translate-y-0 opacity-100': isAnimating }"
    >
      {{ visibleMessage }}
    </span>
  </div>
</template>
